define('SimulatePageState/SimulatePageState',[
    "common/urlUtils"
],
    function (urlUtils) {

        function start() {
            let params = urlUtils.parseQueryParamsFromUrl();

            if (params.ed == 1) {
                // Show or hide cookie banner. The delay is here to make sure our code will run after the native CookieBot code runs (so we don't hide the banner, and CookieBot then displays it again, or vice versa).
                if (params.showCookieDisclaimer == 1) {
                    setTimeout(Cookiebot.show, 3000);
                } else {
                    setTimeout(Cookiebot.hide, 3000);
                }
            }

            //show a tooltip
            if (params.ed == 1 && params.tooltip) {

                var parameter = params.tooltip;
                (function () {
                    var buttons = document.getElementsByClassName('term-dialog-button');
                    var button = buttons[--parameter];
                    var toolTip = button._tippy;
                    toolTip.show();
                }());
            }

            //quiz results 1st answer
            if (params.ed == 1 && params.quizResults == 1) {
                var answerButtons = document.getElementsByClassName('quiz-answer-btn');
                var nextButtons = document.getElementsByClassName('quiz-question-next-button');

                Coria.WaitForSwiper(function () {
                    for (var i = 0; i < nextButtons.length; i++) {
                        answerButtons[i * 4].click();
                        nextButtons[i].click();
                    }
                });
            }

            //quiz results 2nd answer
            if (params.ed == 1 && params.quizResults == 2) {
                var answerButtons = document.getElementsByClassName('quiz-answer-btn');
                var nextButtons = document.getElementsByClassName('quiz-question-next-button');

                Coria.WaitForSwiper(function () {
                    for (var i = 0; i < nextButtons.length; i++) {
                        answerButtons[(i + 1) * 4 - 3].click();
                        nextButtons[i].click();
                    }
                });
            }

            //quiz results 3rd answer
            if (params.ed == 1 && params.quizResults == 3) {
                var answerButtons = document.getElementsByClassName('quiz-answer-btn');
                var nextButtons = document.getElementsByClassName('quiz-question-next-button');

                Coria.WaitForSwiper(function () {
                    for (var i = 0; i < nextButtons.length; i++) {
                        answerButtons[(i + 1) * 4 - 2].click();
                        nextButtons[i].click();
                    }
                });
            }

            //quiz results 4th answer
            if (params.ed == 1 && params.quizResults == 4) {
                var answerButtons = document.getElementsByClassName('quiz-answer-btn');
                var nextButtons = document.getElementsByClassName('quiz-question-next-button');

                Coria.WaitForSwiper(function () {

                    for (var i = 0; i < nextButtons.length; i++) {
                        answerButtons[(i + 1) * 4 - 1].click();
                        nextButtons[i].click();
                    }
                });
            }

            //show quiz modal
            if (params.ed == 1 && params.quizModal == 1) {
                var answersModal = document.getElementsByClassName('quiz-send-copy-button');
                answersModal[0].click();
            }

            //Show the error message on a specific question
            if (params.ed == 1 && params.quizErrorMessage) {
                Coria.WaitForSwiper(function () {
                    if (window.swiperLoaded) {
                        var parameter = params.quizErrorMessage;
                        var quizElement = document.getElementsByClassName("swiper-container")[0];
                        var quizElementId = quizElement.id;
                        var quizSwiper = document.querySelector("#" + quizElementId).swiper;
                        var nextButtons = document.getElementsByClassName('quiz-question-next-button');
                        quizSwiper.slideTo(--parameter);
                        nextButtons[parameter].click();
                    }

                });
            }

            //Navigate to a specific quiz question
            if (params.ed == 1 && params.quizQuestion) {

                Coria.WaitForSwiper(function () {
                    if (window.swiperLoaded) {
                        var parameter = params.quizQuestion;
                        var quizElement = document.getElementsByClassName("swiper-container")[0];
                        var quizElementId = quizElement.id;
                        var quizSwiper = document.querySelector("#" + quizElementId).swiper;
                        quizSwiper.slideTo(--parameter);
                    }

                });
            }

            //Navigate to specific quiz question and select an answer
            if (params.ed == 1 && params.quizQuestion && params.quizAnswerSelected) {

                var answerButtons = document.getElementsByClassName('quiz-answer-btn');
                var nextButtons = document.getElementsByClassName('quiz-question-next-button');
                var questionParam = parseInt(params.quizQuestion);
                var answerParam = parseInt(params.quizAnswerSelected);
                var quizElement = document.getElementsByClassName("swiper-container")[0];
                var quizElementId = quizElement.id;
                var quizSwiper = document.querySelector("#" + quizElementId).swiper;

                if (window.swiperLoaded) {
                    quizSwiper.slideTo(questionParam);
                }

                Coria.WaitForSwiper(function () {
                    answerButtons[(questionParam - 1) * 4 + (answerParam - 1)].click();
                });
            }

            //Display error messages on quiz modal
            if (params.ed == 1 && params.quizModal == 1 && params.modalErrorMessage) {
                var errorMsgParam = params.modalErrorMessage
                var modalErrors = document.getElementsByClassName('alert-danger');
                var currentErrorMsg = modalErrors[--errorMsgParam];
                currentErrorMsg.style.display = "block";
            }

            //Display success messages on quiz modal
            if (params.ed == 1 && params.quizModal == 1 && params.modalSuccessMessage) {
                var successMsgParam = params.modalSuccessMessage
                var modalSuccess = document.getElementsByClassName('alert-success');
                var currentSuccessMsg = modalSuccess[--successMsgParam];
                currentSuccessMsg.style.display = "block";

                //Hide input field and modal footer
                //var modalInput = document.getElementById("useremaildiv_50b3f4bfb36749e7bbd2ff5b787e73b1");
                //var modalFooter = document.getElementById("sendquizresultsbtn_50b3f4bfb36749e7bbd2ff5b787e73b1");
                var modalInput = document.querySelector('[id^="useremaildiv_"]');
                var modalFooter = document.querySelector('[id^="sendquizresultsbtn_"]');
                modalInput.style.display = "none";
                modalFooter.style.display = "none";
            }


            //open Nth modal
            if (params.ed == 1 && params.modal) {

                Coria.WaitForjQuery(function () {

                    jQuery(document).ready(function () {
                        var parameter = params.modal;
                        var selectedModal = $('.modal').eq(--parameter);
                        selectedModal.modal("show");
                    });
                });
            }

            //open all accordions
            if (params.ed == 1 && params.allAccordions) {
                var accordionArrow = document.querySelectorAll(".question-link");
                var accordionContent = document.querySelectorAll(".panel-collapse");

                for (i = 0; i < accordionContent.length; i++) {
                    if (params.allAccordions == 1) {
                        accordionArrow[i].classList.remove("collapsed");
                        accordionContent[i].classList.add("show");
                    }
                    else if (params.allAccordions == 0) {
                        accordionArrow[i].classList.add("collapsed");
                        accordionContent[i].classList.remove("show");
                    }
                }
            }

            //remove isi
            if (params.ed == 1 && params.isi) {
                var elements = document.querySelectorAll('.important-information-banner > .banner-content');
                if (elements.length) {
                    elements[0].remove();
                }
            }

            //open Nth accordion
            if (params.ed == 1 && params.accordion) {
                var parameter = params.accordion;
                var accordionsArrow = document.querySelectorAll(".question-link");
                var accordionsContent = document.querySelectorAll(".panel-collapse");
                var currentAccordionArrow = accordionsArrow[--parameter];
                var currentAccordionContent = accordionsContent[parameter];
                currentAccordionArrow.classList.remove("collapsed");
                currentAccordionContent.classList.add("show");
            }

            //select panels tab
            if (params.ed == 1 && params.panel && params.tab) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        var panelIndex = params.panel;
                        var selectedPanel = $('.tab-container').eq(--panelIndex);
                        if (selectedPanel.length) {
                            var tabIndex = params.tab;
                            tabIndex--;
                            var selectedTab = $(selectedPanel).find('.tab-pane').eq(tabIndex);
                            if (selectedTab.length) {
                                selectedTab.tab("show");
                                tabLink = $(selectedPanel).find('.tab-panel-desktop.nav-item .nav-link').eq(tabIndex);
                                if (tabLink.length)
                                    tabLink.trigger("click");
                            }
                        }
                    });
                });
            }

            //open flexibile accordion
            if (params.ed == 1 && params.flexibleAccordion) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        if (params.flexibleAccordion == "all") {
                            $(".flexible-accordion-component").find(".panel-collapse").collapse('show');
                        }
                        else {
                            var accordionIndex = params.flexibleAccordion;
                            var accordion = $(".flexible-accordion-component").eq(--accordionIndex);
                            if (accordion.length) {
                                $(accordion).find(".panel-collapse").collapse('show');
                            }
                        }
                    });
                });
            }

            //fill element on page (format: id or class|searchValue)
            //for example: txtSearch|Term for search
            if (params.ed == 1 && params.fillElements) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        var elements = params.fillElements.split(",");
                        for (var i = 0; i < elements.length; i++) {
                            var elementWithValue = elements[i].split("|");
                            var element = $("#" + elementWithValue[0]);
                            if (element && element.length) {
                                $(element).val(elementWithValue[1]);                               
                            }
                            else {
                                element = $("." + elementWithValue[0])
                                if (element && element.length) {
                                    $(element).val(elementWithValue[1]);                                    
                                }
                            }
                        }
                    });
                });
            }

            //click on nth element on page (input elements and links)            
            if (params.ed == 1 && params.clickNthElement) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        var elementIndexes = params.clickNthElement.split(",");
                        var elements = $("input[type=submit], button, a[href]");                        
                        for (var i = 0; i < elementIndexes.length; i++) {
                            var elementIndex = parseInt(elementIndexes[i]);
                            if (elements.length > elementIndex) {
                                var element = elements[elementIndex];
                                $(element).click();
                            }
                        }
                    });
                });
            }
            
            //check for nth element on page (input elements and links)
            if (params.ed == 1 && params.getElementsList) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        var elements = $("input[type=submit], button, a[href]");
                        var list = "";                       
                        for (var i = 0; i < elements.length; i++) {
                            var element = elements[i];                            
                            list += "index: " + i + " ";
                            if ($(element).attr("id"))
                                list += "id: " + $(element).attr("id") + " ";
                            if ($(element).attr("name"))
                                list += "name: " + $(element).attr("name") + " ";
                            if (element.innerText)
                                list += "text: " + element.innerText;
                            list += "\<br>";
                        }
                        document.body.innerHTML = list;
                    });
                });
            }

            //hide element selected by id or class
            //visibility hidden because of back to top button
            if (params.ed == 1 && params.hideElement) {
                Coria.WaitForjQuery(function () {
                    jQuery(document).ready(function () {
                        var elementIdentifiers = params.hideElement.split(",");                        
                        for (var i = 0; i < elementIdentifiers.length; i++) {
                            var element = $("#" + elementIdentifiers[i]);
                            if (element && element.length) {
                                $(element).hide();
                                $(element).css("visibility", "hidden");
                            }
                            else {
                                element = $("." + elementIdentifiers[i])
                                if (element && element.length) {
                                    $(element).hide();
                                    $(element).css("visibility", "hidden");
                                }
                            }
                        }
                    });
                });
            }

            //fill form
            if (params.ed == 1 && params.fillForm == 1) {                
                submitForm();
            }

            function submitForm() {
                var submitButton = document.querySelectorAll('input[type="submit"]');
                var formControls = document.getElementsByTagName('input');
                var selectControls = document.getElementsByTagName('select');

                for (i = 0; i < formControls.length; i++) {
                    switch (formControls[i].type.toLowerCase()) {
                        case 'text':
                            if (params[formControls[i].dataset.scFieldName] != undefined)
                                formControls[i].value = params[formControls[i].dataset.scFieldName];
                            else
                                formControls[i].value = '';
                            break;
                        case 'checkbox':
                            if (params[formControls[i].dataset.scFieldName] == "1" || (formControls[i].value == params[formControls[i].dataset.scFieldName])) {
                                formControls[i].checked = false;
                                formControls[i].click();
                            }
                            if (params[formControls[i].dataset.scFieldName] == "0") {
                                formControls[i].checked = false;
                            }
                            break;
                        case 'radio':
                            if (formControls[i].value == params[formControls[i].dataset.scFieldName]) {
                                formControls[i].click();
                            }
                            break;
                    }
                }

                for (i = 0; i < selectControls.length; i++) {
                    selectControls[i].value = params[selectControls[i].dataset.scFieldName];
                }

                if (params.submitWithButton && params.submitForm == 1) {
                    var counter = 0;
                    var intervalId = setInterval(function () {
                        counter++;
                        if (counter > 10) {
                            clearInterval(intervalId);
                            return;
                        }
                        var submitButtons = document.querySelectorAll('input[type="submit"]');
                        for (var i = 0; i < submitButtons.length; i++) {
                            var btn = submitButtons[i];
                            if (btn.name == params.submitWithButton) {
                                $(btn).click();
                                clearInterval(intervalId);
                            }
                        }
                    }, 500);
                }
                else {
                    if (params.submitForm == 1)
                        $(submitButton).click();
                }
            }
        }

        return {
            start: start
        }
    });

